import ServiceExec from '@/common/utils/ServiceExec';
import { asFormData, convertHourMinuteToTime, isEmpty } from '@/common/utils/Util';
import store from '@/store';
import { toastAlert } from '@/common/utils/module/ToastSupport';
import { CODE_ENV_LIST, SMILE_TYPE } from '@/common/constants/ConstCode';
import dayjs from 'dayjs';
import { nativeDownload } from '@/common/utils/module/NativeRequest';
import { announcement } from '@/common/service/apiList';
import { showTextModal } from '@/common/utils/ModalState';
import { cloneDeep } from 'lodash';

const prefix = '/api/user/smile/invitation';
const downloadPrefix = '/api/wreath/smile/download';

export default {
  async saveWithSmile({ state }, payload) {
    const userData = store.getters['user/getUserData'];

    payload.userNo = userData.userNo;
    payload.firstRelation = formatJSONData(payload.firstRelation, 'name');
    payload.secondRelation =
      payload.category === SMILE_TYPE.WEDDING.key ? formatJSONData(payload.secondRelation, 'name') : null;

    payload.firstAccounts = JSON.stringify(payload.firstAccounts);
    payload.secondAccounts =
      payload.category === SMILE_TYPE.WEDDING.key ? JSON.stringify(payload.secondAccounts) : null;

    payload.galleryRawFiles = payload.gallery.filter(e => !e.fileNo && e.type.includes('image/'));
    payload.galleryFileList = payload.gallery.filter(e => e.fileNo && e.storedFileName);

    // const [hour, minute] = payload.eventDateTime.split(':');
    // payload.eventDate = payload.eventDate + 'T' + hour + ':' + minute + ':00';
    // payload.eventDate = payload.eventDate + 'T' + convertHourMinuteToTime(payload.eventDateTime);
    payload.eventDate = payload.eventDate + 'T' + payload.eventDateTime + ':00';

    try {
      const response = await ServiceExec.multiPost(prefix + '/save', asFormData(payload));
      return response.data;
    } catch (e) {
      throw new Error(e);
    }
  },

  async save({ state }, payload) {
    const userData = store.getters['user/getUserData'];
    const reqData = cloneDeep(payload);
    reqData.userNo = userData.userNo;
    // payload.firstRelation = JSON.stringify(payload.firstRelation);
    // payload.secondRelation = JSON.stringify(payload.secondRelation);

    reqData.firstAccounts = reqData.firstAccounts.filter(item => !item.bank?.includes('선택'));
    if (!isEmpty(reqData.secondAccounts)) {
      reqData.secondAccounts = reqData.secondAccounts.filter(item => !item.bank?.includes('선택'));
    }
    reqData.firstRelation = formatJSONData(reqData.firstRelation, 'name');
    reqData.secondRelation = formatJSONData(reqData.secondRelation, 'name');
    reqData.firstAccounts = JSON.stringify(reqData.firstAccounts);
    reqData.secondAccounts = JSON.stringify(reqData.secondAccounts);

    reqData.galleryRawFiles = reqData.gallery.filter(e => !e.fileNo && e.type.includes('image/'));
    reqData.galleryFileList = reqData.gallery.filter(e => e.fileNo && e.storedFileName);

    const [hour, minute] = reqData.eventDateTime.split(':');
    reqData.eventDate = reqData.eventDate + 'T' + hour + ':' + minute + ':00';

    try {
      const response = await ServiceExec.multiPost(prefix + '/save', asFormData(reqData));
      if (response.status !== ServiceExec.status.OK) return false;
      return response.data;
    } catch (e) {
      throw new Error(e);
    }
  },

  async update({ state }, payload) {
    const userData = store.getters['user/getUserData'];
    const reqData = cloneDeep(payload);
    // storedFileName이 있으면 변경사항 X 없으면 기존 이미지에 변경이 있다는 뜻
    if (reqData?.invitationFile?.storedFileName) {
      delete reqData.invitationFile;
    } else {
      delete reqData.invitationImageInfo;
    }
    reqData.userNo = userData.userNo;

    reqData.firstAccounts = reqData.firstAccounts.filter(item => !item.bank?.includes('선택'));
    if (!isEmpty(reqData.secondAccounts)) {
      reqData.secondAccounts = reqData.secondAccounts.filter(item => !item.bank?.includes('선택'));
    }

    reqData.firstRelation = formatJSONData(reqData.firstRelation, 'name');
    reqData.secondRelation = formatJSONData(reqData.secondRelation, 'name');
    reqData.firstAccounts = JSON.stringify(reqData.firstAccounts);
    reqData.secondAccounts = JSON.stringify(reqData.secondAccounts);

    reqData.galleryRawFiles = reqData.gallery.filter(e => !e.fileNo && e.type.includes('image/'));
    reqData.galleryFileList = reqData.gallery.filter(e => e.fileNo && e.storedFileName);

    const [hour, minute] = reqData.eventDateTime.split(':');
    reqData.eventDate = reqData.eventDate + 'T' + hour + ':' + minute + ':00';

    try {
      const response = await ServiceExec.multiPut(prefix + '/update', asFormData(reqData));
      if (response.status !== ServiceExec.status.OK) return false;
      return response.data;
    } catch (e) {
      throw new Error(e);
    }
  },

  async fetchList({ state, commit }, payload) {
    if (payload.nextId == -1) return false;
    try {
      const response = await ServiceExec.get(prefix + '/list', payload);
      commit('setNextId', response.data.pageInfo?.nextId);
      commit('setList', response.data.list ?? []);
    } catch (e) {
      throw new Error(e);
    }
  },

  async fetchDetail({ state, getters, commit }, invitationNo) {
    try {
      const response = await ServiceExec.get(prefix + `/${invitationNo}`);
      if (response?.status !== ServiceExec.status.OK) {
        return false;
      }
      commit('setDetail', response?.data);
      return response?.data;
    } catch (e) {
      throw new Error(e);
    }
  },

  async remove({ state, getters, commit }, invitationNo) {
    try {
      const response = await ServiceExec.delete(prefix + `/${invitationNo}`);
      if (response.status !== ServiceExec.status.OK) {
        await toastAlert('error', '삭제에 실패했습니다.');
        return false;
      }

      const list = getters['getList'];
      commit(
        'mergeList',
        list.filter(e => e.invitationNo !== invitationNo)
      );
      return true;
    } catch (e) {
      throw new Error(e);
    }
  },

  /*
 초대장 다운로드
 */
  async download({ state }, payload) {
    const request = {};
    request.startDate = dayjs(payload.eventDate)
      .subtract(30, 'days')
      .format('YYYY-MM-DD');
    request.endDate = dayjs(payload.eventDate).format('YYYY-MM-DD');
    request.searchText = payload.invitationNo;

    const { data, status } = await ServiceExec.get(downloadPrefix, request);
    console.log('download data', data);
    if (ServiceExec.status.OK !== status) {
      showTextModal(data, '확인');
    }
  }
};

const formatJSONData = (list = [], value = '') => {
  const parsingList = list.filter(e => {
    return e[value] !== null && e[value] !== '';
  });

  if (parsingList.length === 0) return null;

  return JSON.stringify(parsingList);
};
